import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.to && !isLast ? (
                <Link
                  to={item.to}
                  className="transition-colors hover:text-primary-700"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-700" : ""}>
                  {item.label}
                </span>
              )}
              {!isLast && (
                <span className="flex h-3.5 w-3.5 items-center justify-center text-foreground-300">
                  <i className="ri-arrow-right-s-line text-sm"></i>
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}